module.exports = __webpack_public_path__ + "img/pabank.97556e65.png";